<div class="news-container">
    <h2 i18n>Ancytree News</h2>
    <div class="news-content">
        <mat-card class="news-card">
            <mat-card-content>
                <div class="news-header">
                    <div class="news-img-container">
                        <img src=".\assets\image\news\christmasNews.png" alt="">
                    </div>
                    <h1  i18n class="news-title">Christmas gift from us to you! 🎁 </h1>
                </div>
                <div class="news-text-container">
                    <p i18n>Treat yourself or surprise someone you love with a memorable gift in the form of a unique family tree. Use discount code 
                        <span style="font-weight: bold">SANTA30</span> 
                        when placing your order to automatically get a 30% discount. But it gets even better! We also offer free express delivery for faster shipping. 🚚
                    </p>
                    <p i18n>Create your unique family tree today and take advantage of this exclusive Christmas discount! 🎄</p>
                    <p i18n>*The offer is valid until December 31 for one purchase and cannot be combined with other discounts.</p>
                </div>
                <div class="news-date-container">
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card class="news-card">
            <mat-card-content>
                <div class="news-header">
                    <div class="news-img-container">
                        <img src=".\assets\image\news\newrelease.nov.png" alt="">
                    </div>
                    <h1  i18n class="news-title">New Features in Ancytree</h1>
                </div>
                <div class="news-text-container">
                    <p i18n>Explore the latest enhancements in Ancytree! We have now implemented price display in more currencies for a smoother experience. 
                        Klarna is now available in several countries as a payment option for easy and secure transaction management. 
                        Discover our new assistance packages that give you even more control over creating your family tree. 
                        Sign up for a shared digital session and get an overview of Ancytree, learn to create your profile, and upload your GEDCOM file. 
                        Ask questions and get answers instantly! 
                        We also offer other packages to help you create your family tree or receive personal guidance. 
                        Take a look today and start exploring Ancytree!
                    </p>
                </div>
                <div class="news-date-container">
                </div>
            </mat-card-content>
        </mat-card>
       
    </div>
</div>